// IframeDocxPreview.js

import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as componentAction from '../../../store/component.action';

function IframeDocxPreview({ docxUrl }) {
  const dispatch = useDispatch();
  const [state, setState] = useState('');
  const callFunctionbase = async (base64String) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    return URL.createObjectURL(blob);
  };
  useEffect(() => {
    const callFn = async () => {
      if (docxUrl) {
        // call here the api to fetch the local file server from the server
        const res = await dispatch(componentAction.serveTheLocalFileFromServer(`./${docxUrl}`));
        const url = await callFunctionbase(res.split(',')[1]);
        setState(url);
      }
    };

    callFn();
  }, [docxUrl]);

  return <iframe src={state} width="1366px" height="623px" frameBorder="0" />;
}

export default IframeDocxPreview;
